import React from 'react';
import LoadingSpinner from '../../../../components/shared/LoadingSpinner';

import { StringConstantsMixin } from '../mixins/shared/string_constants_mixin';

const createReactClass = require('create-react-class');

const ShareModalDrawerQRCode = createReactClass({
  getInitialState() {
    return {
      loading: true
    };
  },
  downloadQRCode() {
    const qrcodeSrc = this.formatQRCodeSrc();
    _gaq.push(['_trackEvent', 'Share', 'qrcode-download', this.props.shareObject.type]);
    // To set the name of the downloaded file we need to use this fetch-blob-a-click method
    fetch(`${qrcodeSrc}?disposition=attachment`).then(response => {
      response.blob().then(blob => {
        const a = document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = `${this.props.shareObject.name}.png`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      });
    });
  },
  formatQRCodeSrc() {
    const urlBase = `${location.protocol}//${location.host}`;
    return `${urlBase}/qrcode/${this.props.formatViewPath()}`;
  },
  onQRCodeImageLoad() {
    this.setState({ loading: false });
  },
  render() {
    const qrcodeSrc = this.formatQRCodeSrc();
    return (
      <div className="form-holder">
        <div style={{ display: this.state.loading ? 'block' : 'none' }} className="qrcode-placeholder">
          <LoadingSpinner />
        </div>
        <img style={{ display: this.state.loading ? 'none' : 'block' }} className="qrcode" src={qrcodeSrc} onLoad={this.onQRCodeImageLoad} />
        <p>{StringConstantsMixin.strings.SHARE_MODAL.DOWNLOAD_INSTRUCTIONS}</p>
        <hr />
        <div className="share-buttons">
          <button id="download-btn" className="download-qr-code" disabled={this.state.loading} onClick={this.downloadQRCode}>
            {StringConstantsMixin.strings.SHARE_MODAL.DOWNLOAD_QR_CODE}
          </button>
        </div>
      </div>
    );
  }
});

export { ShareModalDrawerQRCode };
